import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Segment } from "semantic-ui-react";
import moment from "moment";
import feathersConnect from "./../../../providers/feathersConnect";
import ATable from "./../../auto/ATable";

const PAGE_RANGE = 10;

function datetimeToFormat(datetime) {
  if (datetime) {
    return moment(datetime.substring(0, 10)).format("DD/MM/YYYY");
  } else {
    return "";
  }
}

class CoopAsambleasView extends Component {
  constructor(props) {
    super(props);

    this.AsambleaService = this.props.feathers.service("/api/asambleas");
  }

  componentDidMount() {}

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: path => {
        dispatch(push(path));
      }
    };
  }

  render() {
    let tipoRadioConfig = {
      defaultValue: "ordinaria",
      options: [
        ["Ordinaria", "ordinaria"],
        ["Extraordinaria", "extraordinaria"]
      ]
    };

    let docPreAsambleaCheckboxConfig = {
      options: [
        ["Convocatoria de asamblea", "docConvocatoriaAsamblea"],
        ["Nomina de Asociados", "docNominaAsociados"],
        [
          "DDJJ del Fondo de Educación y Promoción Cooperativa",
          "docDDJJFondoEducacionPromocion"
        ],
        [
          "Tasa de Actuación Administrativa",
          "docPreTasaActuacionAdministrativa"
        ],
        [
          "Copia del acta de Reunión del Consejo de Administración",
          "docCopiaActaReunionConsejoAdministracion"
        ],
        ["Publicación en el Boletín Oficial", "docPublicacionBoletinOficial"],
        ["Planilla Datos Estadísticos", "docPlanillaDatosEstadisticos"],
        [
          "Estados Contables, notas a los estados contables e informe del auditor",
          "docEstadosContablesNotasEstadosContablesInformeAuditor"
        ],
        ["Memoria anual", "docMemoriaAnual"],
        ["Informe de sindico", "docInformeSindico"],
        [
          "Proyecto de distribución de excedentes",
          "docProyectoDistribucionExcedentes"
        ]
      ]
    };

    let docPostAsambleaCheckboxConfig = {
      options: [
        [
          "Datos Informativos de Consejeros y Síndicos",
          "docDatosInformativosConsejerosSindicos"
        ],
        [
          "Registro de Asistencia de Asociados a la Asamblea",
          "docRegistroAsistenciaAsociadosAsamblea"
        ],
        [
          "Tasa de Actuación Administrativa",
          "docPostTasaActuacionAdministrativa"
        ],
        ["Acta de asamblea", "docActaAsamblea"],
        [
          "Acta de Reunión de consejo de administración",
          "docActaReunionConsejoAdministracion"
        ]
      ]
    };

    let docINAESCheckboxConfig = {
      options: [
        ["DOCUMENTACION RECIBIDA PARA INAES", "docRecibidaINAES"],
        ["DOCUMENTACION ENVIADA A INAES", "docEnviadaINAES"]
      ]
    };

    return (
      <div>
        <ATable
          pageRange={PAGE_RANGE}
          headers={{
            "Convocatoria / Acta": [
              ["convocatoria", datetimeToFormat],
              "actaConvocatoria"
            ],
            "Realizacion / Acta": [
              ["fechaAsamblea", datetimeToFormat],
              "actaRealizacon"
            ],
            "Cierre / Acta Cargos": [
              ["fechaCierreAsamblea", datetimeToFormat],
              "actaDistribucionCargos"
            ],
            "Tipo / Ejercicio Economico": ["tipo", "ejercicioEconomico"]
          }}
          service={this.AsambleaService}
          options={{
            serviceParams: {
              CooperativaId: this.props.cooperativa.id
            }
          }}
          form={{
            fields: [
              ["!Convocatoria", "convocatoria", "datetime", 5],
              ["!Realizacion", "fechaAsamblea", "datetime", 5],
              ["!Cierre", "fechaCierreAsamblea", "datetime", 6],
              ["!Nro Acta Convocatoria", "actaConvocatoria", "input", 4],
              ["!Nro Acta Realizacion", "actaRealizacon", "input", 4],
              ["!Nro Acta Cargos", "actaDistribucionCargos", "input", 4],
              ["!Ejercicio Economico", "ejercicioEconomico", "input", 4],
              ["Tipo", "tipo", "radio", 4, tipoRadioConfig],
              [
                "Documentacion Pre Asamblea",
                "docPreAsamblea",
                "checkbox",
                8,
                docPreAsambleaCheckboxConfig
              ],
              [
                "Documentacion Post Asamblea",
                "docPostAsamblea",
                "checkbox",
                8,
                docPostAsambleaCheckboxConfig
              ],
              [
                "INAES",
                "docPostAsamblea",
                "checkbox",
                8,
                docINAESCheckboxConfig
              ],
              ["!Orden del Dia", "ordenDelDia", "textarea", 16, { rows: 3 }]
            ],
            service: this.AsambleaService,
            options: {
              serviceParams: {
                CooperativaId: this.props.cooperativa.id
              }
            }
          }}
        />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    CoopAsambleasView.mapStateToProps,
    CoopAsambleasView.mapDispatchToProps
  )(CoopAsambleasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopAsambleasView.js